import { render, staticRenderFns } from "./QuickOpDashboardView.vue?vue&type=template&id=08b4c0ba&"
import script from "./QuickOpDashboardView.vue?vue&type=script&lang=js&"
export * from "./QuickOpDashboardView.vue?vue&type=script&lang=js&"
import style0 from "./QuickOpDashboardView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports